/* ============================================================
   STROVIA — shared behaviour
   Ported from html-design/index.html (inline <script>, lines 881–921).
   Vanilla ES5-ish to match the source. Loaded with defer.

   Public API used by sections:
     Strovia.toast(msg)        -> bottom toast
     Strovia.addToCart(id,qty) -> real Shopify AJAX add, then toast
     Strovia.observe(root)     -> wire .reveal + [data-count] inside root
     Strovia.wishlist          -> localStorage wishlist store (see below)
   ============================================================ */
window.Strovia = (function () {
  'use strict';

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.getElementById('StroviaToast');
    if (!t) return;
    var m = document.getElementById('StroviaToastMsg');
    if (m) m.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._h);
    t._h = setTimeout(function () {
      t.classList.remove('show');
    }, 2600);
  }

  /* ---------- Cart ----------
     Real Shopify add-to-cart. Refreshes Dawn's cart bubble so the
     stock header/cart-drawer stays in sync with our custom sections. */
  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('[data-strovia-cart-count]');
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].textContent = cart.item_count;
          nodes[i].classList.toggle('is-empty', cart.item_count === 0);
        }
        document.dispatchEvent(
          new CustomEvent('strovia:cart:updated', { detail: { cart: cart } })
        );
        return cart;
      });
  }

  function addToCart(variantId, qty, title) {
    if (!variantId) {
      toast('This product is unavailable');
      return Promise.resolve();
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          toast(res.description || 'Could not add to cart');
          return;
        }
        return refreshCartCount().then(function () {
          toast((title || res.product_title || 'Item') + ' added to cart');
        });
      })
      .catch(function () {
        toast('Could not add to cart — please try again');
      });
  }

  /* ---------- Wishlist ----------
     Front-end only: an ordered array of product handles in localStorage
     (no backend, mirrors the design's "simulated commerce" spirit but with
     real product handles, so the wishlist page can hydrate real data from
     /products/<handle>.js).

     Any element can become a toggle by carrying
       data-strovia-wish="<product-handle>"  (+ optional data-strovia-wish-title)
     — a delegated click handler below does the rest. Toggles get .is-wished
     and aria-pressed kept in sync; every [data-strovia-wish-count] mirrors the
     item count (with .is-empty at zero, same contract as the cart count). */
  var WISH_KEY = 'strovia:wishlist';

  function wishAll() {
    try {
      var list = JSON.parse(window.localStorage.getItem(WISH_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function wishHas(handle) {
    return wishAll().indexOf(handle) !== -1;
  }

  function wishSync() {
    var list = wishAll();
    var counts = document.querySelectorAll('[data-strovia-wish-count]');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = list.length;
      counts[i].classList.toggle('is-empty', list.length === 0);
    }
    var btns = document.querySelectorAll('[data-strovia-wish]');
    for (var j = 0; j < btns.length; j++) {
      var on = list.indexOf(btns[j].getAttribute('data-strovia-wish')) !== -1;
      btns[j].classList.toggle('is-wished', on);
      btns[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function wishToggle(handle, title) {
    if (!handle) return false;
    var list = wishAll();
    var at = list.indexOf(handle);
    var on = at === -1;
    if (on) list.push(handle);
    else list.splice(at, 1);
    try {
      window.localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (e) {
      toast('Could not save — storage is unavailable');
      return !on;
    }
    wishSync();
    document.dispatchEvent(
      new CustomEvent('strovia:wishlist:updated', { detail: { handles: list } })
    );
    toast((title || 'Item') + (on ? ' saved to your wishlist' : ' removed from your wishlist'));
    return on;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-strovia-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    wishToggle(btn.getAttribute('data-strovia-wish'), btn.getAttribute('data-strovia-wish-title'));
  });

  /* Another tab changed the list -> re-sync counts, hearts and any listener
     (the wishlist page re-renders off this same event). */
  window.addEventListener('storage', function (e) {
    if (e.key !== WISH_KEY) return;
    wishSync();
    document.dispatchEvent(
      new CustomEvent('strovia:wishlist:updated', { detail: { handles: wishAll() } })
    );
  });

  /* ---------- Count-up metrics ---------- */
  function countUp(el) {
    if (el._counted) return;
    var target = parseInt(el.dataset.count, 10);
    /* Guard: countUp OVERWRITES textContent. `data-count` therefore means
       "this element is a number that animates" and nothing else. Refuse to
       run on anything with child elements, or on a non-numeric value — a
       stray data-count on a container would otherwise wipe its children.
       (This happened once: the PDP variant selector carried data-count and
       had its four option buttons replaced by the digit "4".) */
    if (isNaN(target) || el.children.length) return;
    el._counted = true;
    var start = null;
    var dur = 1600;

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = target.toLocaleString();
      return;
    }
    requestAnimationFrame(step);
  }

  /* ---------- Reveals ----------
     When a block reveals, also start the count-up for any [data-count]
     inside it, so numbers animate as the block fades in (not earlier,
     while hidden). A second observer is the safety net for [data-count]
     that isn't wrapped in a .reveal. */
  var io = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        t.classList.add('in');
        var ns = t.querySelectorAll('[data-count]');
        for (var i = 0; i < ns.length; i++) countUp(ns[i]);
        io.unobserve(t);
      });
    },
    { threshold: 0.12 }
  );

  var cio = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        countUp(e.target);
        cio.unobserve(e.target);
      });
    },
    { threshold: 0.6 }
  );

  function observe(root) {
    var scope = root || document;
    scope.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
    scope.querySelectorAll('[data-count]').forEach(function (el) {
      if (!el.closest('.reveal')) cio.observe(el);
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    observe(document);
    wishSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Theme editor: re-wire whenever a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    wishSync();
  });

  return {
    toast: toast,
    addToCart: addToCart,
    refreshCartCount: refreshCartCount,
    countUp: countUp,
    observe: observe,
    wishlist: {
      all: wishAll,
      has: wishHas,
      toggle: wishToggle,
      sync: wishSync
    }
  };
})();
